document.documentElement.classList.add('js');

function initializeShell(header) {
  if (header.dataset.initialized) return;
  header.dataset.initialized = 'true';
  const drawer = header.querySelector('[data-drawer]');
  const opener = header.querySelector('[data-drawer-open]');
  const desktop = window.matchMedia('(min-width: 1000px)');
  let previousOverflow;
  const closeDrawer = () => { if (drawer.open) drawer.close(); };
  opener.addEventListener('click', () => {
    previousOverflow = document.body.style.overflow;
    drawer.showModal();
    drawer.setAttribute('aria-hidden', 'false');
    opener.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('shell-drawer-open');
    drawer.querySelector('[data-drawer-close]').focus();
  });
  drawer.querySelector('[data-drawer-close]').addEventListener('click', closeDrawer);
  drawer.addEventListener('click', (event) => {
    if (event.target !== drawer) return;
    const bounds = drawer.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDrawer();
  });
  drawer.addEventListener('cancel', (event) => { event.preventDefault(); closeDrawer(); });
  drawer.addEventListener('close', () => {
    drawer.setAttribute('aria-hidden', 'true');
    opener.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = previousOverflow ?? '';
    document.body.classList.remove('shell-drawer-open');
    drawer.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
    if (!desktop.matches && opener.isConnected) opener.focus();
  });
  // showModal supplies the native focus trap and makes the background inert.
  header.querySelectorAll('details').forEach((details) => {
    details.addEventListener('toggle', () => {
      details.querySelector(':scope > summary').setAttribute('aria-expanded', String(details.open));
    });
  });
  const closeMegaMenus = () => header.querySelectorAll('[data-mega][data-open]').forEach((menu) => {
    menu.removeAttribute('data-open');
    menu.querySelector(':scope > .shell-header__item-link')?.setAttribute('aria-expanded', 'false');
  });
  const outsideClick = (event) => { if (!header.contains(event.target)) closeMegaMenus(); };
  document.addEventListener('click', outsideClick);
  header.addEventListener('focusout', (event) => { if (event.relatedTarget && !header.contains(event.relatedTarget)) closeMegaMenus(); });
  const resize = () => { closeMegaMenus(); if (desktop.matches) closeDrawer(); };
  desktop.addEventListener('change', resize);
  header.shellCleanup = () => { closeDrawer(); closeMegaMenus(); document.removeEventListener('click', outsideClick); desktop.removeEventListener('change', resize); };
}
document.querySelectorAll('[data-shell-header]').forEach(initializeShell);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-shell-header]').forEach(initializeShell));
document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-shell-header]').forEach((header) => header.shellCleanup?.()));

